import { useCIMSNotificationsContext } from '../../CIMSNotificationsContext'
import { useCheckPermissions } from 'hooks/useCheckPermission'
import { NotificationEventItem } from 'shared'
import PrefixContent from '../PrefixContent'
import EditContent from './components/EditContent'
import ViewContent from './components/ViewContent'
import { useCIMSNotificationsPanelContext } from '../CIMSNotificationsPanelContext'
import CIMSDivider from '../../../CIMSDivider'
import { Store } from 'antd/lib/form/interface'

function PanelContent<T extends NotificationEventItem, U extends Store>() {
  const { event } = useCIMSNotificationsPanelContext<T>()
  const { edit, __debug } = useCIMSNotificationsContext<T, U>()
  const permission = edit(event).permission
  const can = useCheckPermissions(event)

  let children
  if (__debug)
    children = (
      <>
        <CIMSDivider>DEBUG : VIEW CONTENT</CIMSDivider>
        <ViewContent />
        <CIMSDivider>DEBUG : EDIT CONTENT</CIMSDivider>
        <EditContent />
      </>
    )
  else if (can(permission)) children = <EditContent />
  else children = <ViewContent />
  return <PrefixContent>{children}</PrefixContent>
}

export default PanelContent
